import MainLayout from "@/components/layout/admin/MainLayout.vue";
export default {
    name: "JobFinishedContact",
    components: {
        MainLayout
    }
};